import { useEffect, useState } from 'react';
import serviceBuilder from '../helpers/serviceBuilder';
import { ServiceStatus } from '../types/ServiceStatus';
import { ValidationEmailParams } from './validationEmailGet';

export const url = 'validation/email';

const useValidationEmailGet = () => {
  const [service, setService] = useState<ServiceStatus>({
    status: 'init'
  });

  const { start, abort } = serviceBuilder<ValidationEmailParams>('get', {
    url,
    set: setService
  });

  useEffect(() => {
    return () => {
      abort();
    };
  }, []);

  return {
    service,
    sendCode: start
  };
};

export default useValidationEmailGet;
